import { connect } from "react-redux";
import ForgotPasswordPage from "../components/authUI/ForgotPasswordPage";
import { getDistributorInfo, sendForgotPasswordEmail } from "../store/actions/authActions";

const mapStatetoProps = (state) => ({
  //add state here
  isAuthenicated: state.auth.isAuthenicated,
  messageType: state.auth.messageType,
  messageText: state.auth.msgText,
  msgTitle: state.auth.msgTitle,
  distributorName: state.auth.distributor,
  distributorImage: state.auth.distributorImage,
  errorStatus: state.auth.errorStatus
});

const ForgotPasswordContainer = connect(mapStatetoProps, {
  getDistributorInfo,
  sendForgotPasswordEmail
})(ForgotPasswordPage);

export default ForgotPasswordContainer;
